export default "/Resources/5afaf2493ee6c513f5493843421f5d1b.svg";